<div class="m-3 d-flex">
  <div class="profile-card-4 text-center">
    <img src="{{aPanelData.keys.bg}}" class="img img-responsive"> 
    <div class="profile-content">
      <div class="profile-name" [innerHTML]="app.bypassHtmlSanitizing(aPanelData.title)"></div>
      <div class="profile-description text-left" [innerHTML]="app.bypassHtmlSanitizing(aPanelData.content)"></div>
    </div>
  </div>
</div>